import React from 'react';

import { IInformProps } from './Inform.types';

import Button from '../Button';
import SpinnerOverlay from '../SpinnerOverlay';

import './Inform.scss';

const Inform: React.FC<IInformProps> = ({
	onClose,
	informText,
	children,
	isLoading,
	btnText = 'Ok',
}) => {
	return (
		<div className='f5gInformContainer'>
			{isLoading && <SpinnerOverlay />}
			<div className='f5gInformText'>
				{informText}
			</div>
			{children &&
				<div className='f5gInformDescription'>
					{children}
				</div>
			}
			<div className='f5gInformActions'>
				<Button
					disabled={isLoading}
					large
					onClick={onClose}
					text={btnText}
				/>
			</div>
		</div>
	);
};

export default Inform;
